import type { Codec } from "nats.ws";
import { JSONCodec } from "nats.ws";

import { isEmpty } from "@/utils/object";
import type { UnknownRecord } from "@/utils/type";

interface RPCRequestData {
  args?: unknown[];
  kwargs?: UnknownRecord;
}

export class NatsRPCPayload {
  args: unknown[];
  kwargs: UnknownRecord;
  codec: Codec<unknown> = JSONCodec();

  constructor({ args = [], kwargs = {} }: RPCRequestData = {}) {
    this.args = args;
    this.kwargs = kwargs;
  }

  encode(): Uint8Array {
    const RPCData = this.prepareRPCRequestData();
    if (Object.keys(RPCData).length === 0) {
      return new Uint8Array(0);
    }
    return this.codec.encode(RPCData);
  }

  private prepareRPCRequestData(): RPCRequestData {
    const RPCData: RPCRequestData = {};
    if (this.args.length > 0) {
      RPCData.args = this.args;
    }
    if (!isEmpty(this.kwargs)) {
      RPCData.kwargs = this.kwargs;
    }
    return RPCData;
  }
}
